import type { ArgumentArray } from 'classnames';
import classNames from 'classnames';
import { extendTailwindMerge } from 'tailwind-merge';

import { FONT_SIZE_TOKENS } from './constants';

const twMerge = extendTailwindMerge({
  extend: { classGroups: { 'font-size': [{ text: FONT_SIZE_TOKENS }] } },
});

export const mergeTwClasses = (...inputs: ArgumentArray): string => twMerge(classNames(...inputs));
